import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconZoomOut: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"zoom-out, search-minus"} maskId="square-filled-radius-0-stroke-1-IconZoomOut"><path fillRule="evenodd" clipRule="evenodd" d="M11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19C13.0295 19 14.8824 18.2443 16.2928 16.999L20.2509 20.957L20.958 20.2499L16.9999 16.2918C18.2447 14.8815 19 13.029 19 11C19 6.58172 15.4183 3 11 3ZM14.5 10.5V11.5H7.5V10.5H14.5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconZoomOut;
